import { DatePicker } from "antd";
import React from "react";
import moment, { Moment } from "moment";
import { DATE_FORMAT1 } from "../constants/stringConstants";
import { isEmpty } from "lodash";
import HeaderModalText from "./HeaderModalText";

function ModalDatePicker({headerText,dateValue,handleChangeDate,isDateDisabled,hasError,isRequired}) {
  console.log({dateValue})
  
  const asterikSign = () => (
    <h2
      style={{
        color: "red",
        fontSize: "20px",
        marginLeft: "5px",
        height:20
      }}
    >
      {" "}
      *
    </h2>
  );


  return (

<div>
<div style={{display:'flex',alignItems:'center',flexDirection:'row'}}>
<HeaderModalText text={headerText}/>
{isRequired && asterikSign()}
</div>
<DatePicker
      style={{width:'100%',borderRadius:10,padding:'10px',height:"50px", border:hasError?"2px solid red":"1.5px solid #d9d9d9"}}    
      disabled={isDateDisabled}
      // disabledDate={(current) => {
      //   let customDate = moment().format("YYYY-MM-DD");
      //   return current && current < moment(customDate, "YYYY-MM-DD");
      // }}
      dropdownClassName="fr-intrvw__dt-clndr"
      value={isEmpty(dateValue)?'':moment(dateValue)}
      format={DATE_FORMAT1}
      onChange={(date) => { console.log({abc:date.target});handleChangeDate(date)}}
      allowClear={false}
    />
</div>

   
  );
}

export default ModalDatePicker;

ModalDatePicker.defaultProps={
  hasError:false
}
